<template>
  <div class="chart-content">
    <div ref="print" id="printElement">
      <div class="position-profile-page page-card-wrapper">
        <div class="page-card-title">
          <div
            class="left-side-text"
            v-if="$store.state.patient.selectedPatient"
          >
            {{ $store.state.patient.selectedPatient.alias }}
            <span v-if="$store.state.patient.selectedPatient.podMac"
              >({{
                $store.state.patient.selectedPatient.podMac.substr(-4)
              }})</span
            >
          </div>
          <span class="page-card-title-text">{{
            $t('text.body_positions_analysis')
          }}</span>
          <DateRangePicker />
        </div>
        <div class="page-card-content">
          <div v-if="loading" class="loading-chart-wrapper">
            <LoadingAnimation />
          </div>
          <div class="chart-wrapper mt-15" v-else>
            <div class="chart-content">
              <div class="hour-title">
                <span class="hour-item pt-2 pb-2 active">
                  <img
                    class="inline-block"
                    src="../../assets/image/time-icon.png"
                  />
                </span>
                <span
                  v-for="hour in hours"
                  :key="hour.value"
                  class="hour-item pt-2 pb-2"
                  :class="hour.active ? 'active' : ''"
                  >{{ hour.show ? hour.label : '' }}</span
                >
              </div>
              <div>
                <div v-for="(day, index) in data" :key="index" class="day-item">
                  <div class="day-title inline-block">
                    Day {{ index + 1 }}
                    <span>
                      ({{
                        userLang.indexOf('en') > -1
                          ? moment(day[0]['Date']).format('DD MMM YY')
                          : moment(day[0]['Date']).format('DD/MM/YY')
                      }})
                    </span>
                  </div>
                  <div class="position-wrapper inline-block">
                    <div v-for="(hour, index) in day" :key="index">
                      <el-tooltip
                        placement="bottom"
                        effect="light"
                        v-if="
                          (!positionFilters.length ||
                            positionFilters.indexOf(hour.Position) > -1 ||
                            hour.IsRed === positionRedStatus.noData ||
                            hour.IsRed === positionRedStatus.unkonwnPosition) &&
                            hour.BlockWidth
                        "
                        class="inline-block mark position-item"
                        :class="
                          hour.IsRed === positionRedStatus.noData
                            ? 'no-connection-box'
                            : hour.IsRed === positionRedStatus.darkRed
                            ? 'light-red-bg'
                            : hour.IsRed === positionRedStatus.lightRed
                            ? 'more-lighter-red-red'
                            : 'pod-unclipped-wrapper'
                        "
                        :style="{
                          width: hour.BlockWidth
                            ? (hour.BlockWidth / 86400) * 100 + '%'
                            : 0,
                          left: (hour.StartToToday / 1000 / 86400) * 100 + '%'
                        }"
                      >
                        <div
                          slot="content"
                          class="body-position-tooltip-content"
                        >
                          <div class="flex mb-15">
                            <span class="grey-circle mr-10 v-h-center">
                              <img
                                class="w-12"
                                :src="images.lyingOnBack"
                                v-if="hour.Position === 'LYING'"
                              />
                              <img
                                class="w-12"
                                :src="images.lyingLeftSide"
                                v-if="hour.Position === 'LEFT'"
                              />
                              <img
                                class="w-12"
                                :src="images.lyingRightSide"
                                v-if="hour.Position === 'RIGHT'"
                              />
                              <img
                                class="w-15"
                                :src="images.sitting"
                                v-if="hour.Position === 'SIT'"
                              />
                              <img
                                class="w-15"
                                :src="images.standing"
                                v-if="hour.Position === 'STAND'"
                              />
                            </span>
                            <div class="inline-block">
                              <div class="title-label secondary-font">
                                Position
                              </div>
                              <div v-if="hour.Position === 'LYING'">
                                {{ $t('text.lying') }}
                              </div>
                              <div v-else-if="hour.Position === 'LEFT'">
                                {{ $t('text.lying_left_side') }}
                              </div>
                              <div v-else-if="hour.Position === 'RIGHT'">
                                {{ $t('text.lying_right_side') }}
                              </div>
                              <div v-else-if="hour.Position === 'SIT'">
                                {{ $t('text.sitting') }}
                              </div>
                              <div v-else-if="hour.Position === 'STAND'">
                                {{ $t('text.standing_walking') }}
                              </div>
                              <div v-else>-</div>
                            </div>
                          </div>
                          <div class="flex">
                            <img
                              :src="images.greyTime"
                              class="w-30 h-30 mr-10"
                            />
                            <div class="inline-block">
                              <div class="title-label secondary-font">
                                {{
                                  $t('text.time_in_pos') | firstLetterCapitalize
                                }}
                              </div>
                              <div>{{ hour.TimeinSecond | secondFormat }}</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <!-- Displays the slash image  -->
                          <img
                            :src="images.podUnclipped"
                            v-if="
                              hour.IsRed === positionRedStatus.unkonwnPosition
                            "
                            class="pod-unclipped-img"
                          />
                          <img
                            class="red-alert"
                            :src="images.redAlert"
                            v-if="
                              hour.IsRed === positionRedStatus.darkRed &&
                                isTimeToReposition
                            "
                          />
                          <div
                            class="possible-intervention-box"
                            v-if="
                              isPossibleIntervention &&
                                hour.isPossibleIntervention
                            "
                          ></div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="time-location-text">
            {{ $t('text.all_times_are_in') }} {{ location || '--' }}
          </div>
          <div class="operation-panel">
            <div>
              <div class="refresh-wrapper">
                <span
                  class="inline-block v-h-center green-circle mr-8 blackish-green-bg"
                  ><img :src="images.refresh"
                /></span>
                <span class="mr-5"
                  >{{ $t('text.repositioning') }}: {{ rev }}
                  {{ $t('text.per_day') }}</span
                >
                <span class="secondary-font">({{ $t('text.avg') }})</span>
              </div>
              <div class="legend">
                <span class="legend-title">{{ $t('text.legend') }}</span>
                <br class="show-mobile" />
                <span class="legend-item-wrapper">
                  <span class="legend-item-block light-red-bg mr-10"></span>
                  <span>{{
                    $t('text.stayed_in_one_position').toLowerCase()
                  }}</span>
                </span>
                <span class="legend-item-wrapper">
                  <span class="legend-item-block mr-10 pod-unclipped-wrapper">
                    <img :src="images.podUnclipped" class="pod-unclipped-img" />
                  </span>
                  <span>{{ $t('text.pod_unclipped').toLowerCase() }}</span>
                </span>
                <span class="legend-item-wrapper">
                  <span
                    class="legend-item-block mr-10 change-in-position-bg"
                  ></span>
                  <span>{{ $t('text.change_in_position').toLowerCase() }}</span>
                </span>
                <span class="legend-item-wrapper">
                  <span
                    class="legend-item-block no-pod-data-block mr-10"
                  ></span>
                  <span>{{ $t('text.no_pod_data').toLowerCase() }}</span>
                </span>
                <span class="legend-item-wrapper" v-if="isPossibleIntervention">
                  <span class="grey-circle mr-10 blackish-green-bg">
                    <img :src="images.possibleIntervention" />
                  </span>
                  <span>{{ $t('text.possible_intervention') }}</span>
                </span>
              </div>
            </div>
            <div class="mt-20">
              <span class="mr-10">{{
                $t('text.body_position_goal').toUpperCase()
              }}</span>
              <div class="show-mobile mb-5"></div>
              <span
                class="goal-btn"
                :class="
                  goalEnabled
                    ? 'blackish-green-bg white-font'
                    : 'light-grey-bg dark-grey-font'
                "
                >{{ goalEnabled ? $t('text.on') : $t('text.off') }}</span
              >
              <span
                class="blue-font pointer"
                @click="toBodyPositionGoals()"
                v-if="p('Patients.Goals.Position.View')"
                >({{ $t('text.tap_to_setup_body_position_goals') }})</span
              >
            </div>
          </div>
          <el-divider class="mt-15 mb-15"></el-divider>
          <div class="chart-filters">
            <div>
              <span class="mr-10">{{
                $t('text.chart_filters').toUpperCase()
              }}</span>
              <span
                class="blue-font pointer"
                @click="filtersShow = !filtersShow"
                >({{
                  filtersShow ? $t('text.tap_to_hide') : $t('text.tap_to_show')
                }})</span
              >
            </div>
            <el-collapse-transition>
              <div v-show="filtersShow">
                <div class="mt-10 filter-row-wrapper">
                  <div class="w-110 inline-block">
                    {{ $t('text.position') }}
                  </div>
                  <div class="inline-block filter-icon-wrapper">
                    <span
                      class="mr-25 pointer filter-item"
                      @click="updatePositionFilters('LYING')"
                    >
                      <span
                        class="mr-10 grey-circle"
                        :class="
                          isPositionFilterSelected('LYING')
                            ? 'blackish-green-bg'
                            : ''
                        "
                      >
                        <img class="w-12" :src="images.lyingOnBack" />
                      </span>
                      <span>{{ $t('text.lying') }}</span>
                    </span>
                    <span
                      class="mr-25 pointer filter-item"
                      @click="updatePositionFilters('LEFT')"
                    >
                      <span
                        class="grey-circle mr-10"
                        :class="
                          isPositionFilterSelected('LEFT')
                            ? 'blackish-green-bg'
                            : ''
                        "
                      >
                        <img class="w-12" :src="images.lyingLeftSide" />
                      </span>
                      <span>{{ $t('text.lying_left_side') }}</span>
                    </span>
                    <span
                      class="mr-25 pointer filter-item"
                      @click="updatePositionFilters('RIGHT')"
                    >
                      <span
                        class="grey-circle mr-10"
                        :class="
                          isPositionFilterSelected('RIGHT')
                            ? 'blackish-green-bg'
                            : ''
                        "
                      >
                        <img class="w-12" :src="images.lyingRightSide" />
                      </span>
                      <span>{{ $t('text.lying_right_side') }}</span>
                    </span>
                    <span
                      class="mr-25 pointer filter-item"
                      @click="updatePositionFilters('SIT')"
                    >
                      <span
                        class="grey-circle mr-10"
                        :class="
                          isPositionFilterSelected('SIT')
                            ? 'blackish-green-bg'
                            : ''
                        "
                      >
                        <img class="w-15" :src="images.sitting" />
                      </span>
                      <span>{{ $t('text.sitting') }}</span>
                    </span>
                    <span
                      class="mr-25 pointer filter-item"
                      @click="updatePositionFilters('STAND')"
                    >
                      <span
                        class="grey-circle mr-10"
                        :class="
                          isPositionFilterSelected('STAND')
                            ? 'blackish-green-bg'
                            : ''
                        "
                      >
                        <img class="w-15" :src="images.standing" />
                      </span>
                      <span>{{ $t('text.standing_walking') }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div
            class="mt-40 detail-table-wrapper"
            id="detail-table-wrapper"
            style="display: none"
          >
            <div class="table-title">{{ $t('text.body_position') }}</div>
            <el-table
              size="mini"
              :data="tableData"
              border
              style="width: 100%;"
              class="mb-20 detail-table"
            >
              <el-table-column
                prop="MinTime"
                :label="$t('text.from').toUpperCase()"
              >
                <template slot-scope="scope">
                  {{ moment(scope.row.MinTime).format('DD-MMM-YYYY hh:mma') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="MaxTime"
                :label="$t('text.to').toUpperCase()"
              >
                <template slot-scope="scope">
                  {{ moment(scope.row.MaxTime).format('DD-MMM-YYYY hh:mma') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="Position"
                :label="$t('text.position').toUpperCase()"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.Position === 'LYING'">
                    {{ $t('text.lying') }}
                  </div>
                  <div v-else-if="scope.row.Position === 'LEFT'">
                    {{ $t('text.lying_left_side') }}
                  </div>
                  <div v-else-if="scope.row.Position === 'RIGHT'">
                    {{ $t('text.lying_right_side') }}
                  </div>
                  <div v-else-if="scope.row.Position === 'SIT'">
                    {{ $t('text.sitting') }}
                  </div>
                  <div v-else-if="scope.row.Position === 'STAND'">
                    {{ $t('text.standing_walking') }}
                  </div>
                  <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="TimeinPosition"
                :label="$t('text.time_in_position').toUpperCase()"
              >
                <template slot-scope="scope">
                  {{ scope.row.TimeinSecond | secondFormat }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="action-btns mt-20">
      <div
        class="action-btn"
        @click="share()"
        v-if="p('Patients.Charts.BodyPosition.Share')"
      >
        <svg-icon
          iconClass="share"
          class="w-15 mr-10"
          className="white-font"
        ></svg-icon>
        <span>{{ $t('text.share') }}</span>
      </div>
      <div
        class="action-btn"
        @click="print()"
        v-if="p('Patients.Charts.BodyPosition.Print')"
      >
        <svg-icon
          iconClass="report"
          class="w-15 mr-10"
          className="white-font"
        ></svg-icon>
        <span>{{ $t('text.print') }}</span>
      </div>
    </div>
    <ShareDialog ref="shareDialog" />
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '@/services/ApiService.js'
import ShareDialog from '@/components/patients/charts/ShareDialog'
import { positionRedStatus, images, hours } from '@/const.js'
import swal from 'sweetalert'
import DateRangePicker from '@/components/patients/charts/DateRangePicker'
import LoadingAnimation from '@/components/patients/charts/LoadingAnimation'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import $ from 'jquery'

// @ is an alias to /src
export default {
  data() {
    return {
      moment,
      userLang: navigator.language || navigator.userLanguage,
      positionRedStatus,
      hours: hours,
      data: [],
      loading: false,
      images: images,
      filtersShow: false,
      goalEnabled: false,
      positionFilters: [],
      isTimeToReposition: false,
      isPossibleIntervention: false,
      rev: 0,
      location: null
    }
  },
  components: {
    ShareDialog,
    DateRangePicker,
    LoadingAnimation
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId': function() {
      this.getData()
    },
    '$store.state.patient.selectedDateRange': function() {
      this.getData()
    }
  },
  mounted: function() {
    this.getData()
  },
  computed: {
    subject() {
      return this.$t('text.position_chart')
    },
    tableData() {
      let tableData = []
      this.data.forEach(item => {
        item.forEach(subItem => {
          if (typeof subItem.Id !== 'undefined') {
            tableData.push(subItem)
          }
        })
      })
      return tableData
    }
  },
  methods: {
    handleClickTimeToRepositionBtn() {
      this.isTimeToReposition = !this.isTimeToReposition
    },
    handleClickPossibleInterventionBtn() {
      this.isPossibleIntervention = !this.isPossibleIntervention
      if (this.isPossibleIntervention) this.isTimeToReposition = true
    },
    updatePositionFilters(val) {
      let index = this.positionFilters.indexOf(val)
      if (index > -1) {
        this.positionFilters.splice(index, 1)
      } else {
        this.positionFilters.push(val)
      }
    },
    isPositionFilterSelected(val) {
      return this.positionFilters.indexOf(val) > -1
    },
    getData() {
      if (!this.$store.state.patient.selectedPatient) return false
      this.data = []
      this.loading = true
      ApiService.GetPositionChart(
        this.$store.state.patient.selectedPatient.patientId,
        moment(this.$store.state.patient.selectedDateRange[0]).format(
          'YYYY-MM-DD'
        ),
        moment(this.$store.state.patient.selectedDateRange[1]).format(
          'YYYY-MM-DD'
        )
      )
        .then(response => {
          this.loading = false
          this.goalEnabled = response.data.goalEnabled
          this.location = response.data.data.Location
          this.getNightTime(
            response.data.data.nightTimeStart,
            response.data.data.nightTimeEnd
          )
          this.rev = response.data.rev
          this.data = []
          let data = response.data.data.positionData
          let startDate = moment(
            this.$store.state.patient.selectedDateRange[0]
          ).format('YYYY-MM-DD')
          let endDate = moment(
            this.$store.state.patient.selectedDateRange[1]
          ).format('YYYY-MM-DD')
          for (var item in data) {
            let newItem = data[item]
            //When the daily data is empty, only one data is put in to show the time
            if (!newItem.length) {
              newItem = [{}]
            }

            // Filter out data outside the time range selected by the user
            let date = item.split('T')[0]
            if (
              moment(date).isBefore(startDate) ||
              moment(date).isAfter(endDate)
            ) {
              continue
            }
            newItem[0].Date = date
            newItem.forEach(ele => {
              if (ele.MinTime && ele.MaxTime) {
                let minTime =
                  ele.MinTime.split('T')[0] + ' ' + ele.MinTime.split('T')[1]
                let maxTime =
                  ele.MaxTime.split('T')[0] + ' ' + ele.MaxTime.split('T')[1]
                ele.StartToToday = moment(minTime, 'YYYY-MM-DD HH:mm:ss').diff(
                  date + ' ' + '00:00:00',
                  'YYYY-MM-DD HH:mm:ss',
                  'seconds'
                )
                //The starting position of the block on the page is shown in terms of MinTime and MaxTime, and when the user hover, it shows the exact TimeinPosition
                ele.BlockWidth = moment(maxTime).diff(
                  moment(minTime),
                  'seconds'
                )
              }
            })
            this.data.push(newItem)
          }
        })
        .catch(() => {
          this.loading = false
          this.data = []
          swal({
            icon: 'error',
            title: this.$t('text.failed'),
            text: this.$t('text.failed_to_get_chart_data')
          })
        })
    },
    toBodyPositionGoals() {
      this.$router.push({
        path: '/patients/position-goal'
      })
    },
    // Dynamically determine the nighttime time range
    getNightTime(nightTimeStart, nightTimeEnd) {
      nightTimeStart =
        moment().format('YYYY-MM-DD') + ' ' + nightTimeStart.split('.')[0]
      nightTimeEnd =
        moment().format('YYYY-MM-DD') + ' ' + nightTimeEnd.split('.')[0]
      this.hours.forEach(hour => {
        const hourValue = moment().format('YYYY-MM-DD') + ' ' + hour.value
        // Consider whether the night time is short or not
        if (moment(nightTimeStart).isAfter(nightTimeEnd)) {
          hour.active =
            moment(hourValue).isSameOrAfter(nightTimeStart) ||
            moment(hourValue).isBefore(nightTimeEnd)
        } else {
          hour.active =
            moment(hourValue).isSameOrAfter(nightTimeStart) &&
            moment(hourValue).isBefore(nightTimeEnd)
        }
      })
    },
    share() {
      this.$refs.shareDialog.openDialog('position_profile')
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let options = {
        backgroundColor: null,
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        removeContainer: false,
        onclone: doc => {
          $(doc)
            .find('body')
            .css('width', '1600px')
          $(doc)
            .find('.new-design .sidebar-type-page-content')
            .css('width', '100%')
          $(doc)
            .find('.new-design .page-card-wrapper')
            .css('max-width', 'unset')
          $(doc)
            .find('.new-design .page-card-wrapper .page-card-content')
            .css('height', 'auto')
          $(doc)
            .find('.new-design .chart-filters .filter-row-wrapper .filter-item')
            .css('display', 'inline-block')
          $(doc)
            .find('.show-mobile')
            .css('display', 'none')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .page-card-title-text'
            )
            .css('margin-top', 0)
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .left-side-text'
            )
            .css('display', 'inline-block')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .date-wrapper'
            )
            .css('position', 'absolute')
            .css('top', '6px')
            .css('right', '10px')
          $(doc)
            .find('.el-range-editor .el-range-input')
            .css('line-height', '24px')
          $(doc)
            .find('.position-profile-page .chart-wrapper')
            .css('min-height', 'unset')
          $(doc)
            .find('#detail-table-wrapper')
            .css('display', 'block')
          $(doc)
            .find('.el-table th')
            .css('display', 'table-cell')
          $(doc)
            .find('.position-profile-page .legend')
            .css('display', 'inline-block')
            .css('float', 'right')
            .css('margin-top', 0)
          $(doc)
            .find('.position-profile-page .legend-item-wrapper')
            .css('width', 'auto')
            .css('margin-top', 0)
        }
      }
      html2canvas(this.$refs.print, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image'
        })
      })
    }
  }
}
</script>

<style>
.position-profile-page .el-table,
.el-table__body-wrapper,
.el-table__footer-wrapper,
.el-table__header-wrapper,
.el-table__header,
.el-table__body,
.el-table__footer,
.el-table__empty-block {
  width: 100% !important;
}
</style>
